/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { StoreApi, UseBoundStore } from 'zustand';
import { SdsDivProps } from '../Component.props';
import { ToastStore } from './Toast.state';
import { TOAST_TYPE_INFO, ToastType } from './Toast.types';

/**
 * The props for `<Toast />`.
 */
export interface ToastProps extends SdsDivProps {
  /**
   * The duration to wait before automatically closing the toast.
   */
  autoCloseDelay?: number;

  /**
   * Provide a custom icon for the toast header.
   */
  customIcon?: JSX.Element;

  /**
   * Toggle the display of the toast icon.
   */
  showIcon?: boolean;

  /**
   * Toggle the display of the toast.
   */
  showToast: boolean;

  /**
   * The state store to handle the appearance of the toast.
   */
  stateHandler: UseBoundStore<StoreApi<ToastStore>>;

  /**
   * The toast title.
   */
  title?: string;

  /**
   * The toast content.
   */
  toastContent?: JSX.Element;

  /**
   * The toast type.
   */
  toastType?: ToastType;
}

/**
 * The default prop values for `<Toast />`.
 */
export const toastDefaults = {
  autoCloseDelay: 5000,
  showIcon: true,
  showToast: false,
  toastType: TOAST_TYPE_INFO,
};
